import { render, staticRenderFns } from "./RolesCreateModal.vue?vue&type=template&id=5bb3be5e&scoped=true&"
import script from "./RolesCreateModal.vue?vue&type=script&lang=js&"
export * from "./RolesCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./RolesCreateModal.vue?vue&type=style&index=0&id=5bb3be5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3be5e",
  null
  
)

export default component.exports